'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module4Res1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module4Res1, _Component);

  function Module4Res1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module4Res1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module4Res1.__proto__ || (0, _getPrototypeOf2.default)(Module4Res1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      module: 'Module 3',
      title: 'Summary'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module4Res1, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                this.state.module
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, xs: 12, sm: 12 },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Review of Getting Ready and Module 1'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'The Australian Guide to Healthy Eating and Serves'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We introduced the ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Australian Guide to Healthy Eating'
                  ),
                  '. The main messages from the guide are that:'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'A large proportion of children\'s diet should come from ',
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'vegetables, legumes and fruit'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Children should drink plenty of ',
                      _react2.default.createElement(
                        'strong',
                        { className: styles.orangeText },
                        'water'
                      ),
                      ' each day'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      '\'Discretionary\' foods should only be eaten sometimes, or in small amounts'
                    )
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We encourage you to ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'become familiar with what a \'serve of vegetable\' looks like'
                  ),
                  '. This will help to make sure you and your family are eating enough vegies. It is also important to remember that the recommended numbre of serves for each food group changes as your child gets older.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Review of Module 2'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'Eating \'HELPS\''
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The focus of Module 2 was the home food environment. We introduced \'HELPS\' steps to encourage healthy eating. This guide reminds us to ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'set aside a time and place where we can sit and eat '
                  ),
                  'our prepared food, preferably when we are hungry and are not distracted. We also looked at ways to encourage healthy eating at home, such as having ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'healthy food accessible and available'
                  ),
                  '.'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'Chopping up vegetables'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'In Module 2, we also discussed ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'routinely chopping up vegetables'
                  ),
                  ' so that they are ready to eat ahead of time. Remember, you can also provide fruit cups in natural juice, or something similar, every now and then instead of washing and chopping up whole fruits each time.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Review of Module 3'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'P\'s and C\'s'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'In Module 3, we introduced the P\'s and C\'s framework. This provided helpful tips on how to divide the responsibility of eating between parent and child. \'P\' stands for \'Parents\', whose job it is to \'Plan\', \'Prepare\' and \'Provide\' healthy foods at regular times throughout the day. \'C\' stands for \'Children\', whose job it is to \'Choose if\', \'Choose what\' and \'Choose how much\' of the food provided that they would like to eat.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'It is the parent\'s responsibility to provide the food, but that is where their job stops, and it\'s the child\'s decision whether when and how much to eat.'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'Role Modelling'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Children will look to parents for guidance about what they should be eating. It is important for parents to',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    ' model good eating practices'
                  ),
                  ' in front of their child to help encourage children to eat their vegies and other healthy foods.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Review of Module 4 - Planning for the future'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Being organised is one of the best ways to make these changes easier. Where possible, try to plan ahead of time and identify situations that you know might be difficult. We encourage you to refer to the Resources regularly and feel free to print them off. We have also provided in Module 4 Resources a list of websites you might find helpful. For more information, please look over the factsheets provided in the resources section of this module.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Summing up'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We encourage you to go through information provided in the modules again. In the resources section, we have provided a list of useful websites you might find helpful.'
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module4Res1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module4Res1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/4/Res1.js
// module id = 1255
// module chunks = 0